var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.68,10a.77.77,0,0,0,0-.15,4.4,4.4,0,0,0-4.4-4.4,4.36,4.36,0,0,0-1.77.38,5.48,5.48,0,0,0-9.23,4,.77.77,0,0,0,0,.15A4.39,4.39,0,0,0,1,14.25a7.52,7.52,0,0,0,1.73,4.4H21.35A7.81,7.81,0,0,0,23,14.25,4.39,4.39,0,0,0,19.68,10ZM3,14.25a2.38,2.38,0,0,1,1.81-2.31l1.55-.4L6.31,10a1.15,1.15,0,0,0,0-.19,3.49,3.49,0,0,1,5.87-2.47l1,.9,1.21-.53a2.35,2.35,0,0,1,.78-.19L5.94,16.65H3.76A4.87,4.87,0,0,1,3,14.25Zm17.28,2.4H8.76L17.12,8.3a2.37,2.37,0,0,1,.58,1.46,1,1,0,0,0,0,.17l-.06,1.61,1.56.4A2.38,2.38,0,0,1,21,14.25,5.11,5.11,0,0,1,20.28,16.65Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnection);
export default __webpack_public_path__ + "static/media/no_connection.9fb50dc085f841b21ac8e05c5a5c84ca.svg";
export { ForwardRef as ReactComponent };